import React, { createContext, useMemo, useState } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
const DynamicThemeContext = /*#__PURE__*/createContext();
const DynamicThemeProvider = _ref => {
  let {
    children,
    theme,
    getInitialMainColor
  } = _ref;
  const [mainColor, setMainColor] = useState(() => {
    try {
      var _getInitialMainColor;
      return (_getInitialMainColor = getInitialMainColor === null || getInitialMainColor === void 0 ? void 0 : getInitialMainColor()) !== null && _getInitialMainColor !== void 0 ? _getInitialMainColor : null;
    } catch (_) {
      return null;
    }
  });
  const muiTheme = useMemo(() => createMuiTheme(theme(mainColor)), [theme, mainColor]);
  return /*#__PURE__*/React.createElement(DynamicThemeContext.Provider, {
    value: {
      mainColor,
      setMainColor
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: muiTheme
  }, children));
};
DynamicThemeProvider.propTypes = {
  theme: PropTypes.func.isRequired,
  getInitialMainColor: PropTypes.func
};
export { DynamicThemeProvider, DynamicThemeContext };